module.exports = __webpack_public_path__ + "static/20211221-banner-correntes-02afe6bc934d1692b51a2ea1546d1bf8.webp";